/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlare = createReactComponent("flare", "IconFlare", [
  ["path", { d: "M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z", key: "svg-0" }]
]);

export { IconFlare as default };
//# sourceMappingURL=IconFlare.js.map
